export const lastSelectedWebsiteSelector = (state) => state.get('lastSelectedWebsite').get('id');
